import { useEffect, useState } from 'react';
import {
    detectPlatform,
    hasInstallPrompt,
    isStandalone,
    subscribeToInstallPrompt,
    type Platform,
} from '../lib/install';

interface InstallState {
    platform: Platform;
    installed: boolean;
    canPrompt: boolean;
}

export const useInstall = (): InstallState => {
    const [canPrompt, setCanPrompt] = useState(hasInstallPrompt);
    const [installed, setInstalled] = useState(isStandalone);

    useEffect(() => subscribeToInstallPrompt(() => setCanPrompt(hasInstallPrompt())), []);

    useEffect(() => {
        const media = window.matchMedia('(display-mode: standalone)');
        const onChange = (): void => setInstalled(isStandalone());
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, []);

    return { platform: detectPlatform(), installed, canPrompt };
};
